import { createRouter, createWebHistory } from 'vue-router';
import useAuthStore from '@/stores/checkAuth';

const ProjectCreator = () => import('@/views/ProjectCreator.vue');
const ReportGenerator = () => import('@/views/ReportGenerator.vue');
const ReleaseNoteGenerator = () => import('@/views/ReleaseNoteGenerator.vue');
const Login = () => import('@/views/LoginPage.vue');
const routes = [
  {
    path: '/report-generator',
    name: 'report-generator',
    component: ReportGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: '/create',
    name: 'project-creator',
    component: ProjectCreator,
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: { hideNavbar: true },
  },
  {
    path: '/release-note-generator',
    name: 'release-note-generator',
    component: ReleaseNoteGenerator,
    meta: { requiresAuth: true },
  },
];

const base = process.env.BASE_URL || '/';

const router = createRouter({
  history: createWebHistory(base),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth) {
    next();
    return;
  }
  const authStore = useAuthStore();
  const isAuthenticated = await authStore.checkAuthStatus();
  if (!isAuthenticated) {
    next({
      path: '/',
      query: { redirect: to.fullPath },
    });
  } else if (to.path === '/' && isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

export default router;
